export default "__VITE_ASSET__CaXepaaW__"